function r(n,e=null){if(n==null)return e;try{return JSON.parse(n)}catch{return e}}export{r as safeJsonParse};
